module.exports = __webpack_public_path__ + "img/horizontal_5_1_6000.bb3dced6.png";